import { useCurrencyAmountFormatter } from '@routable/shared';
import React from 'react';
import {} from 'interfaces/redux';
import { ExternalBlock, ExternalBlockItem } from 'modules/external/ExternalBlocksSection';
export const ExternalReceiptBatchPaymentHeader = ({ payment }) => {
    const { formatCurrencyAmount } = useCurrencyAmountFormatter();
    const { amount, currencyCode: currency } = payment;
    return (React.createElement(ExternalBlock, { className: "external-receipt-payment-header" },
        React.createElement(ExternalBlockItem, null,
            React.createElement("span", { className: "text-sm text-grey-60" }, "Amount you'll receive"),
            React.createElement("span", { className: "external-receipt-payment-header__price text-black" }, formatCurrencyAmount({ amount, currency })))));
};
